import jwtDecode from "jwt-decode";

function getJwt() {
  return localStorage.getItem("token");
}

function login(token) {
  localStorage.setItem("token", token);
}

function getCurrentUser() {
  try {
    const jwtToken = localStorage.getItem("token");
    return jwtDecode(jwtToken);
  } catch (error) {
    return null;
  }
}

export { login, getCurrentUser, getJwt };
